const response_types = [
    { 
        responseTypeId: 0, 
        description: 'No Response Yet', 
        label: '', 
        color: 'grey--text text--darken-3' 
    },
    { 
        responseTypeId: 1, 
        description: 'Acknowledged and Accepted', 
        label: 'Acknowledge and Accept', 
        color: 'green--text' 
    },
    { 
        responseTypeId: 2, 
        description: 'Acknowledged with Concern', 
        label: 'Acknowledge with Concern', 
        color: 'red--text' 
    },
    { 
        responseTypeId: 3, 
        description: 'Discussion Requested', 
        label: 'Request Discussion', 
        color: 'orange--text' 
    },
]

export default response_types